var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandCertificatesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#fcd535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 28.6641H16.1667C15.2462 28.6641 14.5 27.9179 14.5 26.9974V15.3307C14.5 14.4103 15.2462 13.6641 16.1667 13.6641H27.8333C28.7538 13.6641 29.5 14.4103 29.5 15.3307V26.9974C29.5 27.9179 28.7538 28.6641 27.8333 28.6641H26.5833M22 27.8307C23.3807 27.8307 24.5 26.7115 24.5 25.3307C24.5 23.95 23.3807 22.8307 22 22.8307C20.6192 22.8307 19.5 23.95 19.5 25.3307C19.5 26.7115 20.6192 27.8307 22 27.8307ZM22 27.8307L22.0178 27.8306L19.3572 30.4912L17.0002 28.1341L19.5164 25.618M22 27.8307L24.6607 30.4912L27.0177 28.1341L24.5015 25.618M19.5 16.9974H24.5M17.8333 19.9141H26.1667",
    stroke: "#000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandCertificatesActive);
export default __webpack_public_path__ + "static/media/BrandCertificates_Active.77911b24949a37127f0d3d7d6a31d392.svg";
export { ForwardRef as ReactComponent };